var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.catalogProductPage},[_c('p',[_vm._v("The product you selected is not currently available in this market")])])}
var staticRenderFns = []

export { render, staticRenderFns }